declare const require: any;
const { version: appVersion } = require('../../../package.json');

export const VERSION = appVersion;